var _path, _g, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg111(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3297_23983",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.0112305H17.0522V19.8647H0V0.0112305Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3297_23983)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57307 1.51123C2.91607 1.51123 1.54007 2.85323 1.50107 4.50823V15.2272C1.46507 16.9282 2.80507 18.3282 4.49007 18.3652H12.5731C14.2421 18.3052 15.5631 16.9282 15.5521 15.2322V6.33923L10.9181 1.51123H4.58507H4.57307ZM4.58507 19.8652H4.45907C1.94707 19.8112 -0.0529317 17.7232 0.00106828 15.2112V4.49023C0.0600683 2.00923 2.10807 0.0112305 4.57007 0.0112305H4.58807H11.2371C11.4411 0.0112305 11.6361 0.0942305 11.7781 0.24123L16.8441 5.51823C16.9771 5.65723 17.0521 5.84423 17.0521 6.03723V15.2272C17.0681 17.7362 15.1121 19.7752 12.5991 19.8652H4.58507Z",
    fill: "#342F4D"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2986 6.984H13.5446C11.7136 6.979 10.2266 5.487 10.2266 3.659V0.75C10.2266 0.336 10.5626 0 10.9766 0C11.3906 0 11.7266 0.336 11.7266 0.75V3.659C11.7266 4.663 12.5426 5.481 13.5466 5.484H16.2986C16.7126 5.484 17.0486 5.82 17.0486 6.234C17.0486 6.648 16.7126 6.984 16.2986 6.984Z",
    fill: "#342F4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14258 14.6997C7.72858 14.6997 7.39258 14.3637 7.39258 13.9497V7.90869C7.39258 7.49469 7.72858 7.15869 8.14258 7.15869C8.55658 7.15869 8.89258 7.49469 8.89258 7.90869V13.9497C8.89258 14.3637 8.55658 14.6997 8.14258 14.6997Z",
    fill: "#342F4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14125 14.699C7.94225 14.699 7.75025 14.62 7.61025 14.478L5.26525 12.124C4.97325 11.83 4.97425 11.355 5.26725 11.063C5.56125 10.771 6.03625 10.771 6.32825 11.065L8.14125 12.887L9.95425 11.065C10.2463 10.771 10.7213 10.771 11.0153 11.063C11.3083 11.355 11.3093 11.83 11.0173 12.124L8.67225 14.478C8.53225 14.62 8.34025 14.699 8.14125 14.699Z",
    fill: "#342F4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg111);
export default __webpack_public_path__ + "static/media/svg111.d47c90a33db0a2253b1f8469668c7064.svg";
export { ForwardRef as ReactComponent };